import { validateTime } from '@elfsight/widget-utils';
import { parse } from 'fast-time-input';
import { isValidTimeInput } from './isValidTimeInput';

type ParseAndFormatTimeType = {
  inputValue: string;
  validValue: string;
};

export const parseAndFormatTime = ({
  inputValue,
  validValue
}: ParseAndFormatTimeType) => {
  if (!inputValue.trim()) {
    return '';
  }

  if (!isValidTimeInput(inputValue)) {
    return validValue;
  }

  const parsed24 = parse(inputValue, '24hr');
  const isParsedAsDefault = parsed24 === '00:00';
  const isParsedToDefaultWithoutZero =
    isParsedAsDefault && !inputValue.includes('0');
  const isInvalidParsedTime = !validateTime(parsed24) && parsed24;

  if (isParsedToDefaultWithoutZero || isInvalidParsedTime) {
    return validValue;
  }

  return parsed24;
};
